<template>
    <v-toolbar v-if="$slots['breadcrumbs']">
        <slot name="breadcrumbs" />
    </v-toolbar>
    <v-divider v-if="$slots['breadcrumbs']" />
    <slot name="content" />
</template>
